var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQrcode = function SvgQrcode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.667 6h6V0h-6v6Zm2-4h2v2h-2V2Zm6-2v6h6V0h-6Zm4 4h-2V2h2v2Zm-12 10h6V8h-6v6Zm2-4h2v2h-2v-2Zm11-2h1v4h-3v-1h-1v3h-2V8h3v1h2V8Zm0 5h1v1h-1v-1Zm-2 0h1v1h-1v-1Z",
    fill: "#03D47C"
  })));
};
export default SvgQrcode;